import React, { useEffect, useRef, useState } from 'react';
import styles from './Jeemocktest.module.css'
import "./carousel_testhighlight.css"
import mockhighlightIcon1 from '../../assets/highlight_expert_1.svg'
import mockhighlightIcon2 from '../../assets/highlight_test_2.svg'
import mockhighlightIcon3 from '../../assets/hightlight_detailed_3.svg'
import mockhighlightIcon4 from '../../assets/hightlight_acess_4.svg'
import mockhighlightIcon5 from '../../assets/highlight_score_5.svg'
import mockhighlightIcon6 from '../../assets/highlight_skill_7.svg'
import mockcardprepared from '../../assets/prepared_expert.svg'
import mockcardtest from '../../assets/test_highlight.svg'
import mockcardaccess from '../../assets/access_detained.svg'
import mockcardexam from '../../assets/exam_simulation.svg'
import mockcardscore from '../../assets/score_card.svg'
import mockcardlearn from '../../assets/exam_skills.svg'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css"; // Use this for older versions
import "swiper/swiper.min.css"; // Alternative if the above doesn't work
import { Navigation,Autoplay, Pagination } from "swiper"; // Use 'swiper' instead of 'swiper/modules'
const cards = [
    { id: 1, text: "Questions based on the latest JEE (Adv.) pattern prepared by expert Aakash Faculty", img: mockcardprepared, title: "Prepared by Experts"},
    { id: 2, text: "Participate to compete with other aspirants at an All India Level", img: mockcardtest, title: "India's Largest Mock Test" },
    { id: 3, text: "All students appearing for Aakash Mock Test to get access to detailed solutions", img: mockcardaccess, title: "Access Detailed Solutions" },
    { id: 4, text: "Aakash Mock Test provides a replica of competitive exams testing experience", img: mockcardexam, title: "Exam Simulation" },
    { id: 5, text: "Scorecard containing subject-wise marks and percentile score along with expected All India Rank (AIR)", img: mockcardscore, title: "Score card" },
    { id: 6, text: "Improve crucial skills such as time management, how to attempt questions, etc", img: mockcardlearn, title: "Learn Exam Skills" },
  ];


const JeeTestHighlight = () => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    const items = wrapper.querySelectorAll(".items > *");

    const handleScroll = () => {
      const scrollPosition = wrapper.scrollLeft;
      const containerCenter = wrapper.offsetWidth / 2;

      items.forEach((item) => {
        const itemCenter =
          item.offsetLeft - wrapper.offsetLeft + item.offsetWidth / 2;
        const distanceFromCenter = Math.abs(
          containerCenter - (itemCenter - scrollPosition)
        );

        // Scale and opacity effect
        const scale = Math.max(0.88, 1 - (distanceFromCenter / containerCenter) * 0.3);
        const opacity = Math.max(0.2, 1 - (distanceFromCenter / containerCenter) * 0.2);
        // Box shadow intensity (closer to center = stronger shadow)
        const shadowIntensity = Math.max(17, -4 - (distanceFromCenter / containerCenter) * 15);
        const boxShadow = `0px 8px ${shadowIntensity}px rgba(16, 24, 40, 0.25)`;
        item.style.transform = `scale(${scale})`;
        item.style.opacity = opacity;
        item.style.boxShadow = boxShadow;
      });
    };

    wrapper.addEventListener("scroll", handleScroll);
    handleScroll(); // Trigger on load

    return () => wrapper.removeEventListener("scroll", handleScroll);
  }, []);

  //desktop slider
  const [width, setWidth] = useState(window.innerWidth * 0.8); // 80% of screen width

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth * 0.8); // Recalculate on resize
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className={`${styles.jee_test_highlight_wrapper}  ${styles.d_block}`}>
        <div className={`container ${styles.JeeTestHighlight}`}>
          <h2>Test highlights</h2>
        </div>
        <div className={styles.slider_container} style={{ width: width, margin: "auto" }}>
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        slidesPerView={1.5} // Show part of the left & right cards
        spaceBetween={30}
        loop={true} // Enable infinite scrolling
        navigation // Enable next/prev arrows
        centeredSlides={true} // Center the active slide
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
      >
        {cards.map((card, index) => (
          <SwiperSlide key={index}>
            <div className={styles.card}>
              <div className={styles.card_testhighlight}>
                <div className={styles.card_imgsection}><img src={card.img} alt=""/></div>
                <div className={styles.card_content_test}>
                  <h6>{card.title}</h6>
                  <p>{card.text}</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
         {/* Custom Pagination Div */}
      <div className="pagination-container">
        <div className="swiper-pagination"></div>
      </div>
        
    </div>
      </div>

      {/* ---------MOCK NEET TEST HIGHlight */}
      <div className={`${styles.jeemocktest_bg} ${styles.m_block}`}>
        <div className='container p-0'>
          <div className={`${styles.jeemocktest_heading}`}>
            <h2>Test highlights</h2>
          </div>
          <div className="scroll_x wrapper" ref={wrapperRef}>
            <ul className="items">
              <li>
                {/* box1 */}
                <div className={`${styles.mocktesthighlight_box1}`}>
                  <div className={`${styles.mocktest_icon2}`}>
                    <img src={mockhighlightIcon1} alt="mocktest" />
                  </div>
                  <div className={`${styles.mocktest_content}`}>
                    <h2>Prepared by Experts</h2>
                    <p>Questions based on the latest NEET pattern prepared by expert Aakash Faculty</p>
                  </div>
                </div>
                {/* box1 */}
              </li>
              <li> {/* box2 */}
                <div className={`${styles.mocktesthighlight_box1}`}>
                  <div className={`${styles.mocktest_icon1}`}>
                    <img src={mockhighlightIcon2} alt="mocktest" />
                  </div>
                  <div className={`${styles.mocktest_content}`}>
                    <h2>India's Largest Mock Test</h2>
                    <p>Participate to compete with other aspirants at an All India Level</p>
                  </div>
                </div>
                {/* box2 */}
              </li>
              <li>
                {/* box3 */}
                <div className={`${styles.mocktesthighlight_box1}`}>
                  <div className={`${styles.mocktest_icon3}`}>
                    <img src={mockhighlightIcon3} alt="mocktest" />
                  </div>
                  <div className={`${styles.mocktest_content}`}>
                    <h2>Access Detailed Solutions</h2>
                    <p>All students appearing for Aakash Mock Test to get access to detailed solutions</p>
                  </div>
                </div>
                {/* box3 */}
              </li>
              <li>
                {/* box4 */}
                <div className={`${styles.mocktesthighlight_box1}`}>
                  <div className={`${styles.mocktest_icon4}`}>
                    <img src={mockhighlightIcon4} alt="mocktest" />
                  </div>
                  <div className={`${styles.mocktest_content}`}>
                    <h2>Exam Simulation</h2>
                    <p>Aakash Mock Test provides a replica of competitive exams testing experience</p>
                  </div>
                </div>
                {/* box4 */}
              </li>
              <li>
                {/* box5 */}
                <div className={`${styles.mocktesthighlight_box1}`}>
                  <div className={`${styles.mocktest_icon5}`}>
                    <img src={mockhighlightIcon5} alt="mocktest" />
                  </div>
                  <div className={`${styles.mocktest_content}`}>
                    <h2>Score card</h2>
                    <p>Scorecard containing subject-wise marks and percentile score along with expected All India Rank (AIR)</p>
                  </div>
                </div>
                {/* box5 */}
              </li>
              <li>
                {/* box6 */}
                <div className={`${styles.mocktesthighlight_box1}`}>
                  <div className={`${styles.mocktest_icon6}`}>
                    <img src={mockhighlightIcon6} alt="mocktest" />
                  </div>
                  <div className={`${styles.mocktest_content}`}>
                    <h2>Learn Exam Skills</h2>
                    <p>Improve crucial skills such as time management, how to attempt questions, etc</p>
                  </div>
                </div>
                {/* box6 */}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default JeeTestHighlight